<template>
       <nav>
        <v-app-bar
            color="red"
            dark
            flat 
            app
            :style="$vuetify.rtl ? {right: 0} :{left: 0}"
        >
            <v-app-bar-nav-icon @click="openSlider()"></v-app-bar-nav-icon>
           
            <v-toolbar-title><img width="196" height="56" :src="require('@/assets/logo-bg1.png')" alt=""></v-toolbar-title>

            <v-spacer></v-spacer>

         <div class="user-setting ">
           <v-menu
            transition="slide-y-transition"
            bottom
            class="ml-2 mr-2"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                dark
                v-bind="attrs"
                v-on="on"
              >
                <v-avatar size="30" class="ml-2 mr-2"><img :src="require(`@/assets/languages/${activeLang.img}`)" alt=""></v-avatar>
                {{$t(`navbare.languages.${activeLang.code}`)}}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(lang, i) in languages"
                :key="i"
                @click="changeLanguage(lang)"
              >
                <v-list-item-avatar size="34">
                <img :src="require(`@/assets/languages/${lang.img}`)" alt="">
                </v-list-item-avatar>
                <v-list-item-title class="text-capitalize font-weight-medium">
                {{$t(`navbare.languages.${lang.code}`)}}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
           <v-btn text :ripple="true" fab><v-icon >fa fa-moon-o <!--fa fa-sun-o--> fa-5x</v-icon></v-btn>
         </div>
         
         <AppNavDropDown v-if="this.$store.state.User != null" />

        </v-app-bar>
        <!--rtl use right=true-->
        <v-navigation-drawer :right='$vuetify.rtl' 
        :mini-variant="minimizeSlider"
        v-model="open"
        :permanent='permanetSlider'
        fixed
        :clipped="true"
        class="red accent-4"
        dark
        app
        tag="aside"
        >
      <v-list >
        <v-list-item
          v-for="link in links"
          :key="link.title"
          link
          :to="link.path"
          active-class="aside-active-link"
          exact
          :ripple="true"
        >
          <v-list-item-icon >
            <v-icon v-text="link.icon"></v-icon>
            <v-expand-transition>
            <p v-show="minimizeSlider"  class="icon-title font-weight-bold" >{{$t(link.title)}}</p>
            </v-expand-transition>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="text-uppercase font-weight-bold">{{$t(link.title)}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          to="/login"
          active-class="aside-active-link"
          exact
          :ripple="true"
          v-if="this.$store.state.User==null"
        >
          <v-list-item-icon >
            <v-icon >fa-sign-in</v-icon>
            <p v-show="minimizeSlider" :style="$vuetify.rtl ? {bottom: '-27px'} :''" class="icon-title font-weight-bold">{{$t("navbare.links.login")}}</p>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="text-uppercase font-weight-bold" >{{$t("navbare.links.login")}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
        <v-list-item
          active-class="aside-active-link"
          :ripple="true"
          v-else
          style="cursor:pointer"
          @click="logout()"
        >
          <v-list-item-icon >
            <v-icon >fa-sign-out</v-icon>
            <p v-show="minimizeSlider" :style="$vuetify.rtl ? {bottom: '-27px'} :''" class="icon-title font-weight-bold">{{$t("navbare.links.logout")}}</p>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="text-uppercase font-weight-bold">{{$t("navbare.links.logout")}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
        </nav>
</template>
<script>
import AppNavDropDown from './NavDropDowMenu.vue';
import firebase from '@/firebase/index';

export default {
    name:'navebar',
    data(){
        return {
            ripple:{"center":true,"class":'active'},
            logoutLoading:true,
            activeLang:{
                code:'en',
                img:'en.jpg'
              },
            languages:[
              {
                code:'ar',
                img:'ar.jpg'
              },
              {
                code:'en',
                img:'en.jpg'
              },
              {
                code:'fr',
                img:'fr.png'
              }
            ],
            link:true,
            minimizeSlider:true,
            permanetSlider:true,
            open:true,
            links:[{
                title:"navbare.links.home",
                path:'/',
                icon:'fa-home'
            },
            {
                title:'navbare.links.order',
                path:'/order',
                icon:'fa-tty'
            },
            {
                title:'navbare.links.reserve',
                path:'/reserve',
                icon:'fa-cutlery'
            },
            {
                title:'navbare.links.contact',
                path:'/contact',
                icon:'fa-comments'
            },
            {
                title:'navbare.links.about',
                path:'/about',
                icon:'fa-exclamation-circle'
            }
            ]
        }
    },
    components:{AppNavDropDown},
    methods:{
        openSlider(){
            if(window.matchMedia('(max-width:600px)').matches){
              this.open=!this.open;
              this.permanetSlider=!this.permanetSlider;
              this.minimizeSlider=true;
              return ;
            }
            this.minimizeSlider=!this.minimizeSlider;
        },
        logout(){
          this.$store.state.LogoutLouding=true;
          const auth=firebase.auth();
          auth.signOut()
           .then(()=>{
                localStorage.removeItem('user');
                this.$store.state.User=null;
                if(this.$route.meta.requiresAuth){
                  this.$store.state.LogoutLouding=false;
                  this.$router.push({path: '/login',query:{redirecto:this.$route.name}});
                }else{
                  setTimeout(()=>{
                    this.$store.state.LogoutLouding=false;
                  },800)
                }
           })
        },
        changeLanguage(value){
          this.$i18n.locale = value.code;
          if (value.code=='ar') {
            this.$vuetify.rtl=true;
          }else{
            this.$vuetify.rtl=false;
          }
          this.activeLang=value;
        }
    }
}
</script>

<style lang="scss">
    .router-link-active{
       background-color: blue;
   }
   .icon-title{
    position: absolute;
    bottom: -16px;
    left: 0;
    width: 100%;
    text-align: center;
    font-size: 7pt !important;
   }
</style>